export const LangFr = {
  name: 'fr',
  data: {
    sidebar: {
      dashboard: 'Tableau de bord',
      identity_validation: 'Validation d’identité',
      profil: 'Mon profil',
      search: 'Recherche de missions',
      file: 'Mes documents',
      mission: 'Mes missions',
      help: 'Aide',
    },
    profil: {
      profil: 'Mon profil',
      account: 'Mon compte',
      knowledge: 'Mon savoir faire',
      proof: 'Mes justificatifs',
      availabilities: 'Mes disponibilités',
      params: 'Paramètres',
    },
    savoir: {
      cv: 'Curriculum Vite',
      exp: 'Expériences',
      skills: 'Compétences',
      lang: 'Languages',
      tools: 'Matériels possédés',
    },
    proof: {
      identity: 'Justificatif d’identité',
      degree: 'Formations',
      licence: 'Permis',
    },
    pennylanePush: {
      alreadyOnPennylane: 'Déjà sur PennyLane',
      skippedCount: '{count} déjà sur PennyLane',
      invoiceSkipped: 'Facture {number} déjà sur PennyLane : rien n’a été envoyé',
    },
    availabilities: {
      myhours: 'Mes horaires',
      dispo: "Périodes d'indisponibilité",
      subtitleH:
        'Indiquez à quelles tranches horaires vous êtes disponible' +
        ' pour travailler.',
      subtitleD: "Indiquez les périodes où vous n'êtes pas du tout disponible.",
    },
    justify: {
      m_vitale_title_c: 'Ajouter une carte vitale',
      m_vitale_title_u: 'Modifier la carte vitale',
      m_vitale_title_d: 'Supprimer une carte vitale',
      m_vitale_d_content:
        'Êtes-vous sûr de vouloir supprimer votre carte' +
        ' vitale ? Cette action est irréversible.',
      m_iban_title_c: 'Ajouter une identité bancaire',
      m_iban_title_u: "Modifier l'identité bancaire",
      m_iban_title_d: 'Supprimer une identité bancaire',
      m_identity_title_c: 'Validation d’identité',
      m_proof_title_c: 'Ajouter un justificatif de domicile',
    },
    missionTasks: {
      titleDe: 'Tâches du {title}',
      titleElided: "Tâches de l'{title}",
    },
    missionHistory: {
      sameTitle: '{count}x ce poste',
      sameTitleDetail: 'Missions « {title} » déjà réalisées : {count}',
      sameTitleSameCompany: 'Dont chez ce client : {count}',
      lastMission: 'Dernière : {company}, du {start} au {end}',
      sameCompany: '{count}x ce client',
      sameCompanyDetail:
        'Missions déjà réalisées chez ce client, tous postes confondus : {count}',
      conflict: 'Déjà en mission',
      conflictDetail: 'Assigné sur des dates qui chevauchent cette mission :',
      conflictItem: 'N°{number} {title} — {company}, du {start} au {end}',
    },
    invoiceImport: {
      modalTitle: 'Importer les factures de {month}',
      modalText:
        'Les factures non importées et celles en erreur seront récupérées depuis Bestt, puis importées dans Pennylane.',
      cancel: 'Annuler',
      confirm: 'Confirmer',
      confirming: 'Lancement…',
      alreadyRunning: 'Un import de ce mois est déjà en cours : sa progression s’affiche.',
      periodInvalid: 'Ce mois ne peut pas être importé.',
      startFailed: 'L’import n’a pas pu être lancé, réessayez.',
      stepBestt: 'Étape 1/2 · Récupération depuis Bestt',
      stepPennylane: 'Étape 2/2 · Import dans Pennylane',
      fetchedCount: '{done} / {total} factures récupérées',
      importedCount: '{done} / {total} factures importées',
      finished: 'Import terminé',
      finishedWithErrors: 'Import terminé avec des erreurs',
      finishedWithErrorsCount: '{done} / {total} importées · {errors} en erreur',
      failed: 'Import impossible',
      fatal: {
        ERR_BESTT_INDISPONIBLE: 'Bestt ne répond pas : rien n’a été importé. Réessayez plus tard.',
        ERR_PASSAGE_INTERROMPU: 'L’import s’est interrompu. Réessayez : rien ne sera importé en double.',
        generic: 'L’import a échoué. Réessayez.',
      },
      close: 'Fermer',
      bannerTitle: 'Erreur lors de l’importation',
      bannerCountOne: '1 facture n’a pas pu être importée',
      bannerCountMany: '{count} factures n’ont pas pu être importées',
      bannerLastRun: 'dernier import le {date} à {time}',
      bannerLastRunBy: 'dernier import le {date} à {time} par {name}',
      retryAll: 'Tout réessayer',
      nothingToRetry: 'Plus aucune facture en erreur pour ce mois.',
      retryFailed: 'Le réessai n’a pas pu être lancé, réessayez.',
      showJournal: 'Voir le journal',
      showErrors: 'Voir les erreurs',
      tooManyInvoices: 'Trop de factures : utilisez Tout réessayer.',
      journalNothingToRetry: 'Plus aucune de ces factures n’est en erreur.',
      informationSaving: 'Une facture de ce mois est en cours d’enregistrement, réessayez dans un instant.',
      listImportOne: 'Import de 1 facture',
      listImportMany: 'Import de {count} factures',
      bannerLastListRunOne: 'dernier import de 1 facture le {date} à {time}',
      bannerLastListRunOneBy: 'dernier import de 1 facture le {date} à {time} par {name}',
      bannerLastListRunMany: 'dernier import de {count} factures le {date} à {time}',
      bannerLastListRunManyBy: 'dernier import de {count} factures le {date} à {time} par {name}',
    },
    invoiceJournal: {
      title: 'Journal d’import · Bestt → Pennylane',
      close: 'Fermer',
      moreActions: 'Plus d’actions',
      openJournal: 'Journal d’import',
      tabToFix: 'À corriger',
      tabHistory: 'Historique',
      retryAll: 'Tout réessayer ({count})',
      loading: 'Chargement du journal…',
      loadFailed: 'Le journal n’a pas pu être chargé',
      reload: 'Recharger',
      emptyTitle: 'Aucune facture à corriger',
      emptyText: 'Aucune facture de {month} n’est en erreur.',
      headerOne: '1 facture est en erreur. Corrigez sa cause, puis réessayez.',
      headerMany: '{count} factures sont en erreur. Elles sont regroupées par cause : corrigez la cause, puis réessayez.',
      groupBesttOne: '1 facture · bloquée à la récupération depuis Bestt',
      groupBesttMany: '{count} factures · bloquées à la récupération depuis Bestt',
      groupPennylaneOne: '1 facture · bloquée à l’import dans Pennylane',
      groupPennylaneMany: '{count} factures · bloquées à l’import dans Pennylane',
      groupOne: '1 facture',
      groupMany: '{count} factures',
      stepBestt: 'Étape 1 · Bestt',
      stepPennylane: 'Étape 2 · Pennylane',
      showGroup: 'Déplier',
      hideGroup: 'Replier',
      howToFix: 'Comment corriger',
      invoiceLine: 'N° {number} · {company}',
      besttClient: 'Client Bestt {id}',
      viewInvoice: 'Voir la facture',
      pdfComesWithImport: 'Le PDF arrive avec l’import',
      code: 'Code : {code}',
      retryGroupOne: 'Réessayer cette facture',
      retryGroupMany: 'Réessayer ces {count} factures',
      and: ' et ',
      errors: {
        ERR_BESTT_FACTURE_INTROUVABLE: {
          label: 'Facture introuvable dans Bestt',
          explanation: 'Bestt dit ne pas connaître ces factures.',
          fix: 'Vérifiez ces factures dans Bestt, puis réessayez.',
        },
        ERR_BESTT_API: {
          label: 'Bestt n’a pas répondu',
          explanation: 'Bestt a échoué sur ces factures.',
          fix: 'Attendez quelques minutes, puis réessayez.',
        },
        ERR_ENTREPRISE_INCONNUE_JOBBIZ: {
          label: 'Client Bestt sans entreprise Jobbiz',
          explanation: 'Aucune entreprise Jobbiz n’a ce client Bestt.',
          fix: 'Renseignez l’identifiant Bestt dans la fiche de l’entreprise, puis réessayez.',
        },
        ERR_ENTREPRISE_AMBIGUE_JOBBIZ: {
          label: 'Client Bestt rattaché à plusieurs entreprises',
          explanation: 'Plusieurs entreprises Jobbiz ont ce client Bestt.',
          fix: 'Ne laissez cet identifiant Bestt qu’à une seule entreprise, puis réessayez.',
        },
        ERR_BESTT_PDF_INDISPONIBLE: {
          label: 'PDF indisponible dans Bestt',
          explanation: 'Bestt n’a pas rendu le PDF de ces factures.',
          fix: 'Attendez quelques minutes, puis réessayez.',
        },
        ERR_STOCKAGE_PDF: {
          label: 'PDF non enregistré',
          explanation: 'Le PDF de ces factures n’a pas pu être rangé ou relu.',
          fix: 'Attendez quelques minutes, puis réessayez.',
        },
        ERR_PENNYLANE_DESACTIVE: {
          label: 'Envoi à Pennylane désactivé hors production',
          explanation: 'Hors production, rien n’est envoyé à Pennylane.',
          fix: 'Rien à corriger : normal hors production.',
        },
        ERR_ENTREPRISE_INTROUVABLE_PENNYLANE: {
          label: 'Entreprise introuvable dans Pennylane',
          explanation: 'Aucun client Pennylane ne correspond à l’entreprise.',
          fix: 'Créez le client dans Pennylane avec le SIRET de l’entreprise, puis réessayez.',
        },
        ERR_ENTREPRISE_AMBIGUE_PENNYLANE: {
          label: 'Plusieurs clients Pennylane pour l’entreprise',
          explanation: 'Plusieurs clients Pennylane ont le SIRET ou le SIREN de l’entreprise.',
          fix: 'N’en gardez qu’un dans Pennylane, puis réessayez.',
        },
        ERR_TVA_TAUX_INCONNU: {
          label: 'Taux de TVA inconnu',
          explanation: 'Le taux de {rates} appliqué sur ces factures n’est pas dans la table de Jobbiz.',
          explanationMany: 'Les taux de {rates} appliqués sur ces factures ne sont pas dans la table de Jobbiz.',
          explanationNoRate: 'Le taux de TVA de ces factures n’est pas dans la table de Jobbiz.',
          fix: 'Prévenez l’équipe technique pour qu’elle ajoute ce taux, puis réessayez.',
        },
        ERR_PENNYLANE_API: {
          label: 'Pennylane a refusé ou n’a pas répondu',
          explanation: 'Pennylane a refusé ces factures ou n’a pas répondu.',
          fix: 'Attendez quelques minutes, puis réessayez.',
        },
        ERR_PENNYLANE_CATEGORIE: {
          label: 'Catégorie non posée dans Pennylane',
          explanation: 'Ces factures sont dans Pennylane ; réessayer ne pose que la catégorie.',
          fix: 'Réessayez : seule la catégorie sera posée.',
        },
        ERR_PENNYLANE_ECHEANCE: {
          label: 'Échéance non posée dans Pennylane',
          explanation: 'Ces factures étaient déjà dans Pennylane ; l’échéance choisie pour elles n’y a pas été posée.',
          fix: 'Réessayez : seule l’échéance sera envoyée.',
        },
        ERR_PENNYLANE_ANNEXE: {
          label: 'Annexe non envoyée dans Pennylane',
          explanation: 'Ces factures sont importées, mais une de leurs annexes n’a pas pu être envoyée dans Pennylane.',
          fix: 'Si une annexe est « à vérifier dans Pennylane », cherchez-la d’abord dans Pennylane : supprimez-la dans Jobbiz, et ajoutez-la à nouveau si Pennylane ne l’a pas. Réessayez ensuite : seules les annexes en attente seront envoyées.',
        },
      },
      unknownError: {
        explanation: 'Cette erreur n’a pas encore de description dans Jobbiz.',
        fix: 'Transmettez le code à l’équipe technique, puis réessayez.',
      },
      history: {
        startedAt: '{date} à {time}',
        import: 'Import',
        listImportOne: 'Import de 1 facture',
        listImportMany: 'Import de {count} factures',
        retry: 'Réessai',
        by: 'par {name}',
        inProgress: 'en cours',
        seconds: '{s} s',
        minutes: '{m} min {s} s',
        hours: '{h} h {m} min',
        fetchedOne: '1 récupérée',
        fetchedMany: '{count} récupérées',
        importedOne: '1 importée',
        importedMany: '{count} importées',
        done: 'Terminé',
        inError: '{count} en erreur',
        running: 'En cours',
        failed: 'Échoué',
        interrupted: 'Interrompu',
        fatal: {
          ERR_BESTT_INDISPONIBLE: 'Bestt ne répondait pas : rien n’a été importé.',
          ERR_PASSAGE_INTERROMPU: 'Rien ne sera importé en double au prochain import.',
          generic: 'L’import a échoué.',
        },
        stepBestt: '1 · Récupération depuis Bestt',
        stepPennylane: '2 · Import dans Pennylane',
        stepFetchedOne: '1 facture récupérée',
        stepFetchedMany: '{count} factures récupérées',
        stepImportedOne: '1 facture importée',
        stepImportedMany: '{count} factures importées',
        toFixOne: '1 facture à corriger → voir l’onglet À corriger',
        toFixMany: '{count} factures à corriger → voir l’onglet À corriger',
        older: 'Voir les passages plus anciens',
        empty: 'Aucun import pour ce mois',
      },
    },
    invoiceDetail: {
      kicker: 'Facture client',
      title: 'N° {number} · {company}',
      titleLoading: 'N° {number}',
      besttClient: 'Client Bestt {id}',
      tabInformation: 'Informations',
      tabHistory: 'Historique',
      tabComments: 'Commentaires',
      loading: 'Chargement de la facture…',
      loadFailed: 'La facture n’a pas pu être chargée.',
      reloadFailed: 'La facture n’a pas pu être relue, rechargez-la.',
      notFound: 'Cette facture est introuvable.',
      reload: 'Recharger',
      banner: {
        notImportedTitle: 'Facture pas encore importée',
        notImportedText: 'Elle sera enregistrée dans Jobbiz et importée dans Pennylane au prochain import.',
        notImportedFetchedText: 'Elle est enregistrée dans Jobbiz et sera importée dans Pennylane au prochain import.',
        errorTitle: '{label} · {code}',
        lateTitleOne: 'Échéance dépassée de 1 jour',
        lateTitleMany: 'Échéance dépassée de {days} jours',
        lateText: 'Reste à payer : {remaining} · échéance au {date}.',
        lateTextNoRemaining: 'Échéance au {date}.',
      },
      information: {
        title: 'Informations',
        amount: 'Montant TTC',
        period: 'Période',
        company: 'Entreprise',
        category: 'Catégorie',
        paymentTerm: 'Délai de paiement',
        noCategory: 'Aucune catégorie',
        unknownCategory: 'Catégorie n° {id}',
        categoryModified: '{value} · modifiée',
        termModified: '{value} · modifié',
        termDefault: '{value} · par défaut',
        termDays: '{days} jours',
        atImport: '{value} · à l’import',
        withDueDate: '{value} · échéance le {date}',
      },
      payment: {
        title: 'Paiement',
        remaining: 'Reste à payer',
        paid: 'Montant réglé',
        paidAt: 'Payée le',
      },
      companyTerms: {
        loadFailed: 'Les conditions de l’entreprise n’ont pas pu être chargées.',
        bonusesTitle: 'Primes & indemnités',
        bonusName: 'Nom',
        bonusUnit: 'Unité',
        bonusRate: 'Majoration',
        noBonuses: 'Aucune prime ni indemnité.',
      },
      preview: {
        live: 'Aperçu chargé en direct depuis Bestt',
        loading: 'Chargement du PDF…',
        busy: 'Un import est en cours, réessayez dans un instant.',
        notFound: 'Le PDF de cette facture est introuvable.',
        besttFailed: 'Bestt n’a pas rendu le PDF, réessayez dans un instant.',
        failed: 'L’aperçu n’a pas pu être chargé.',
        retry: 'Réessayer',
        rotate: 'Pivoter',
        zoomOut: 'Zoom arrière',
        zoomIn: 'Zoom avant',
        previousPage: 'Page précédente',
        nextPage: 'Page suivante',
        pageOf: '{page} / {pages}',
      },
      footer: {
        download: 'Télécharger le PDF',
        import: 'Importer dans Pennylane',
        retry: 'Réessayer l’import',
        running: 'Import en cours…',
        viewInPennylane: 'Voir dans Pennylane',
      },
      messages: {
        nothingToImport: 'Cette facture est déjà importée.',
        nothingToRetry: 'Cette facture n’est plus en erreur.',
        importFailed: 'L’import n’a pas pu être lancé, réessayez.',
        retryFailed: 'Le réessai n’a pas pu être lancé, réessayez.',
      },
    },
    invoiceInformation: {
      title: 'Informations de la facture',
      intro: 'S’applique à la facture n° {number} seulement, pas aux autres factures de l’entreprise.',
      category: 'Catégorie',
      noCategory: 'Aucune catégorie',
      unknownCategory: 'Catégorie n° {id}',
      categoryOfTheCompany: 'Catégorie de l’entreprise',
      categoryOfCompany: 'Catégorie de {company} : {name}',
      companyWithoutCategory: '{company} n’a pas de catégorie par défaut.',
      paymentTerm: 'Délai de paiement',
      paymentTermPlaceholder: 'Choisir un délai',
      termOfTheCompany: 'Délai de l’entreprise',
      termOfTheCompanyWithValue: 'Délai de l’entreprise : {term}',
      termOfCompany: 'Délai de {company} : {term}',
      termDefault: '{term} (par défaut)',
      restore: 'Rétablir',
      cancel: 'Annuler',
      save: 'Enregistrer',
      saving: 'Enregistrement…',
      saved: {
        updated: 'Enregistré dans Jobbiz et dans Pennylane.',
        on_import: 'Enregistré dans Jobbiz ; Pennylane le recevra à l’import.',
        skipped: 'Enregistré dans Jobbiz ; Pennylane n’est pas modifié hors production.',
        unchanged: 'Enregistré dans Jobbiz ; rien à changer dans Pennylane.',
      },
      errors: {
        partialTitle: 'Pennylane n’a pas pris toutes les modifications.',
        category: {
          saved: 'Catégorie : enregistrée.',
          failed: 'Catégorie : non enregistrée, Pennylane l’a refusée ou n’a pas répondu.',
        },
        paymentTerm: {
          saved: 'Délai de paiement : enregistré.',
          failed: 'Délai de paiement : non enregistré, Pennylane l’a refusé ou n’a pas répondu.',
        },
        PENNYLANE_INVOICE_NOT_FOUND: 'Cette facture est introuvable dans Pennylane : ce qui devait y être modifié n’est pas enregistré.',
        IMPORT_ALREADY_RUNNING: 'Un import de ce mois est en cours : réessayez quand il sera terminé.',
        INVOICE_INFORMATION_SAVING: 'Une autre facture de ce mois est en cours d’enregistrement : réessayez dans un instant.',
        INVOICE_WITHOUT_COMPANY: 'Cette facture n’a pas d’entreprise : sa catégorie et son délai ne se modifient pas.',
        generic: 'L’enregistrement a échoué, réessayez.',
      },
    },
    invoiceAppendices: {
      title: 'Annexes',
      add: 'Ajouter une annexe',
      dropHere: 'Glissez une annexe ici, ou utilisez le « + »',
      accepted: 'PDF, JPG ou PNG · 10 Mo max',
      uploading: 'Envoi de {name}…',
      loading: 'Chargement des annexes…',
      retry: 'Réessayer',
      by: 'par {name}',
      addedOn: 'ajoutée le {date}',
      download: 'Télécharger {name}',
      delete: 'Supprimer {name}',
      confirm: 'Elle est bien dans Pennylane',
      confirming: 'Confirmation…',
      confirmed: 'Annexe enregistrée comme envoyée dans Pennylane.',
      unconfirmedHelp: 'Pennylane n’a pas répondu à son envoi : elle y est peut-être. Cherchez-la d’abord dans Pennylane. Si elle y est, confirmez-le ici ; sinon, supprimez-la et ajoutez-la à nouveau.',
      pennylaneUnavailable: 'Annexes Pennylane indisponibles pour le moment.',
      source: {
        jobbiz: 'Jobbiz',
        pennylane: 'Pennylane',
      },
      status: {
        sent: 'Envoyée dans Pennylane',
        pending: 'En attente d’import',
        unconfirmed: 'À vérifier dans Pennylane',
      },
      added: {
        sent: 'Annexe ajoutée et envoyée dans Pennylane.',
        pending: 'Annexe ajoutée : elle sera envoyée dans Pennylane à l’import.',
        skipped: 'Ajoutée dans Jobbiz ; rien n’est envoyé à Pennylane hors production.',
        other: 'Annexe ajoutée.',
      },
      size: {
        locale: 'fr-FR',
        bytes: '{size} o',
        kilobytes: '{size} Ko',
        megabytes: '{size} Mo',
      },
      deleteModal: {
        title: 'Supprimer l’annexe',
        text: '« {name} » sera supprimée de Jobbiz.',
        remainsInPennylane: 'Elle restera dans Pennylane : la supprimer ici ne l’en retire pas. Elle ne sera plus jointe aux mails de Jobbiz.',
        cancel: 'Annuler',
        confirm: 'Supprimer',
        deleting: 'Suppression…',
        deleted: 'Annexe supprimée.',
        deletedRemains: 'Annexe supprimée de Jobbiz ; elle reste dans Pennylane.',
      },
      errors: {
        APPENDIX_FILE_MISSING: 'Aucun fichier reçu : déposez un seul fichier, non vide.',
        FILE_TOO_LARGE: 'Ce fichier dépasse 10 Mo.',
        APPENDIX_FILE_TYPE_INVALID: 'Ce fichier n’est ni un PDF, ni un JPG, ni un PNG.',
        APPENDIX_NOT_FOUND: 'Cette annexe n’existe plus : la liste est relue.',
        APPENDIX_FILE_NOT_FOUND: 'Le fichier de cette annexe est introuvable dans le stockage.',
        PENNYLANE_APPENDIX_FAILED: 'Pennylane a refusé cette annexe : rien n’est gardé.',
        PENNYLANE_APPENDIX_UNCONFIRMED: 'Pennylane n’a pas répondu : l’annexe a pu y être ajoutée. Vérifiez dans Pennylane avant de la déposer à nouveau, sinon elle y serait en double.',
        APPENDIX_NOT_UNCONFIRMED: 'Cette annexe n’est plus à vérifier : la liste est relue.',
        INVOICE_APPENDIX_CONFIRM_FAILED: 'La confirmation a échoué, réessayez.',
        INVOICE_WITHOUT_COMPANY: 'Cette facture n’a pas d’entreprise : elle ne prend pas d’annexe.',
        IMPORT_ALREADY_RUNNING: 'Un import de ce mois est en cours : réessayez quand il sera terminé.',
        INVOICE_INFORMATION_SAVING: 'Une autre facture de ce mois est en cours d’enregistrement : réessayez dans un instant.',
        PENNYLANE_INVOICE_NOT_FOUND: 'Cette facture est introuvable dans Pennylane : l’annexe n’est pas ajoutée.',
        INVOICE_NOT_FOUND: 'Cette facture est introuvable.',
        loadFailed: 'Les annexes n’ont pas pu être chargées.',
        addFailed: 'L’ajout de l’annexe a échoué, réessayez.',
        downloadFailed: 'Le fichier n’a pas pu être téléchargé, réessayez.',
        pennylaneFile: {
          PENNYLANE_APPENDIX_FAILED: 'L’annexe n’a pas pu être récupérée dans Pennylane. Réessayez.',
        },
        deleteFailed: 'La suppression a échoué, réessayez.',
        confirmFailed: 'La confirmation a échoué, réessayez.',
        oneFileOnly: 'Déposez un seul fichier à la fois.',
      },
    },
    invoiceErrors: {
      ERR_BESTT_FACTURE_INTROUVABLE: {
        explanation: 'Bestt dit ne pas connaître cette facture.',
        fix: 'Vérifiez cette facture dans Bestt, puis réessayez.',
      },
      ERR_BESTT_API: {
        explanation: 'Bestt a échoué sur cette facture.',
        fix: 'Attendez quelques minutes, puis réessayez.',
      },
      ERR_ENTREPRISE_INCONNUE_JOBBIZ: {
        explanation: 'Aucune entreprise Jobbiz n’a le client Bestt de cette facture.',
        fix: 'Renseignez l’identifiant Bestt dans la fiche de l’entreprise, puis réessayez.',
      },
      ERR_ENTREPRISE_AMBIGUE_JOBBIZ: {
        explanation: 'Plusieurs entreprises Jobbiz ont le client Bestt de cette facture.',
        fix: 'Ne laissez cet identifiant Bestt qu’à une seule entreprise, puis réessayez.',
      },
      ERR_BESTT_PDF_INDISPONIBLE: {
        explanation: 'Bestt n’a pas rendu le PDF de cette facture.',
        fix: 'Attendez quelques minutes, puis réessayez.',
      },
      ERR_STOCKAGE_PDF: {
        explanation: 'Le PDF de cette facture n’a pas pu être rangé ou relu.',
        fix: 'Attendez quelques minutes, puis réessayez.',
      },
      ERR_PENNYLANE_DESACTIVE: {
        explanation: 'Hors production, rien n’est envoyé à Pennylane.',
        fix: 'Rien à corriger : normal hors production.',
      },
      ERR_ENTREPRISE_INTROUVABLE_PENNYLANE: {
        explanation: 'Aucun client Pennylane ne correspond à l’entreprise.',
        fix: 'Créez le client dans Pennylane avec le SIRET de l’entreprise, puis réessayez.',
      },
      ERR_ENTREPRISE_AMBIGUE_PENNYLANE: {
        explanation: 'Plusieurs clients Pennylane ont le SIRET ou le SIREN de l’entreprise.',
        fix: 'N’en gardez qu’un dans Pennylane, puis réessayez.',
      },
      ERR_TVA_TAUX_INCONNU: {
        explanation: 'Le taux de {rate} appliqué à cette facture n’est pas dans la table de Jobbiz.',
        explanationNoRate: 'Le taux de TVA de cette facture n’est pas dans la table de Jobbiz.',
        fix: 'Prévenez l’équipe technique pour qu’elle ajoute ce taux, puis réessayez.',
      },
      ERR_PENNYLANE_API: {
        explanation: 'Pennylane a refusé cette facture ou n’a pas répondu.',
        fix: 'Attendez quelques minutes, puis réessayez.',
      },
      ERR_PENNYLANE_CATEGORIE: {
        explanation: 'Cette facture est dans Pennylane ; réessayer ne pose que la catégorie.',
        fix: 'Réessayez : seule la catégorie sera posée.',
      },
      ERR_PENNYLANE_ECHEANCE: {
        explanation: 'Cette facture était déjà dans Pennylane ; l’échéance choisie pour elle n’y a pas été posée.',
        fix: 'Réessayez : seule l’échéance sera envoyée.',
      },
      ERR_PENNYLANE_ANNEXE: {
        explanation: 'Cette facture est importée, mais une de ses annexes n’a pas pu être envoyée dans Pennylane.',
        fix: 'Si une annexe est « à vérifier dans Pennylane », cherchez-la d’abord dans Pennylane : supprimez-la dans Jobbiz, et ajoutez-la à nouveau si Pennylane ne l’a pas. Réessayez ensuite : seules les annexes en attente seront envoyées.',
      },
    },
    invoiceHistory: {
      loading: 'Chargement de l’historique…',
      empty: 'Aucun évènement',
      notFound: 'Cette facture est introuvable : elle n’a pas d’historique.',
      loadFailed: 'L’historique n’a pas pu être chargé.',
      retryLoad: 'Réessayer',
      at: '{date} à {time}',
      by: 'par {name}',
      retryBy: 'réessai · par {name}',
      retry: 'réessai',
      automatic: 'automatique',
      migrated: 'Reprise de l’ancien import : historique antérieur indisponible',
      unknownDate: 'Date inconnue',
      transition: '{from} → {to}',
      types: {
        fetched: 'Récupérée depuis Bestt',
        imported: 'Importée dans Pennylane',
        import_failed: 'Erreur d’import',
        pennylane_category_set: 'Catégorie posée dans Pennylane',
        category_changed: 'Catégorie modifiée',
        payment_term_changed: 'Délai de paiement modifié',
        payment_status_changed: 'Statut de paiement modifié',
        appendix_added: 'Annexe ajoutée',
        appendix_sent: 'Annexe envoyée dans Pennylane',
        appendix_deleted: 'Annexe supprimée',
        sent_by_mail: 'Facture envoyée par mail',
        reminder_sent: 'Relance envoyée',
        litigation_opened: 'Passage en contentieux',
        litigation_closed: 'Sortie du contentieux',
        reminders_suspended: 'Relances automatiques suspendues',
        reminders_resumed: 'Relances automatiques reprises',
        unknown: 'Autre évènement',
      },
      details: {
        linked: 'Rattachée : Pennylane avait déjà cette facture',
        sent: 'Envoyée dans Pennylane par Jobbiz',
        noCategory: 'Aucune catégorie',
        unknownCategory: 'Catégorie n° {id}',
        termDays: '{days} jours',
        newDueDate: 'Nouvelle échéance le {date}',
        sameDueDate: 'Échéance inchangée',
        categoryPennylane: {
          updated: 'Mise à jour dans Pennylane',
          on_import: 'Sera posée dans Pennylane à l’import',
          skipped: 'Pennylane non modifié hors production',
        },
        termPennylane: {
          updated: 'Échéance mise à jour dans Pennylane',
          on_import: 'Échéance envoyée à Pennylane à l’import',
          skipped: 'Pennylane non modifié hors production',
        },
        appendix: {
          sent: 'Envoyée dans Pennylane',
          pending: 'En attente d’import',
          skipped: 'Non envoyée dans Pennylane hors production',
        },
        remainsInPennylane: 'Elle reste dans Pennylane',
        confirmedByAdmin: 'Confirmée par un admin',
        reminderLevel: {
          before_due: 'Rappel',
          first: 'Relance 1/3',
          second: 'Relance 2/3',
          third: 'Relance 3/3',
        },
        reminderTrigger: {
          manual: 'manuelle',
          auto: 'automatique',
        },
        recipientsOne: '{count} destinataire',
        recipientsMany: '{count} destinataires',
        redirected: 'Envoyée à l’adresse de test : aucun client ne l’a reçue',
      },
    },
    invoiceComments: {
      tabWithCount: 'Commentaires ({count})',
      loading: 'Chargement des commentaires…',
      empty: 'Aucun commentaire',
      notFound: 'Cette facture est introuvable : elle n’a pas de commentaires.',
      loadFailed: 'Les commentaires n’ont pas pu être chargés.',
      retryLoad: 'Réessayer',
      deletedAuthor: 'Compte supprimé',
      unnamedAuthor: 'Auteur sans nom',
      at: '{date} à {time}',
      inputLabel: 'Votre commentaire',
      placeholder: 'Écrire un commentaire…',
      submit: 'Commenter',
      counter: '{count} / {max}',
      tooLong: 'Un commentaire fait au plus 2 000 caractères.',
      errors: {
        invalid: 'Le commentaire doit faire de 1 à 2 000 caractères.',
        notFound: 'Cette facture est introuvable : le commentaire n’a pas été enregistré.',
        failed: 'Le commentaire n’a pas pu être enregistré. Réessayez.',
      },
    },
    invoiceSendMail: {
      title: 'Envoyer par mail',
      open: 'Envoyer par mail',
      close: 'Fermer',
      intro: 'Les factures sont envoyées en PDF aux contacts de facturation de chaque entreprise.',
      scopesLabel: 'Factures à envoyer',
      scope: {
        selectionOne: 'Cette facture',
        selectionOneDetail: 'N°{number} · {company} · {amount}',
        selectionMany: 'Ces factures',
        selectionManyDetail: '{count} factures sélectionnées',
        company: 'Toutes les factures de {company}',
        group: 'Toutes les factures du groupe {group}',
        invoicesOne: '{count} facture',
        invoicesMany: '{count} factures',
        companiesOne: '{count} entreprise',
        companiesMany: '{count} entreprises',
      },
      recipients: {
        title: 'Destinataires · contacts de facturation de {company}',
        none: 'Aucun contact de facturation pour cette entreprise.',
        member: 'Membre',
        pendingMember: 'Invitation en attente',
        external: 'Externe',
        unnamed: 'Contact sans nom',
      },
      withoutCompany: 'Sans entreprise',
      notSendable: {
        title: 'Écartées, non envoyables :',
        item: 'N°{number} · {status}',
      },
      status: {
        error: 'Erreur',
        draft: 'Brouillon',
        pending: 'En attente',
        partiallyPaid: 'Partiellement payé',
        paid: 'Payé',
        cancelled: 'Annulée',
        notImported: 'Non importé',
      },
      loading: 'Chargement des factures et des contacts…',
      reload: 'Réessayer',
      cancel: 'Annuler',
      sendOne: 'Envoyer {count} facture',
      sendMany: 'Envoyer {count} factures',
      sending: 'Envoi en cours…',
      retrySend: 'Réessayer l’envoi',
      frozenNotice: 'Le premier envoi a peut-être abouti : la sélection est figée. Réessayez l’envoi à l’identique ou fermez la fenêtre.',
      entry: {
        notSendable: 'Seules les factures en attente, partiellement payées ou payées s’envoient par mail.',
        tooMany: 'Envoyer {max} factures au plus à la fois',
      },
      report: {
        sentOne: '{count} facture envoyée',
        sentMany: '{count} factures envoyées',
        failedOne: '{count} facture en échec',
        failedMany: '{count} factures en échec',
        skippedOne: '{count} facture sautée',
        skippedMany: '{count} factures sautées',
        nothingSent: 'Aucune facture envoyée',
        replayed: 'Cet envoi avait déjà été fait : rien n’a été renvoyé.',
        line: '{company} : {reason}',
        noRecipient: 'aucun destinataire coché',
        unknownCompany: 'Une entreprise',
      },
      companyErrors: {
        INVOICE_PDF_MISSING: 'le PDF d’une facture manque',
        APPENDIX_FILE_NOT_FOUND: 'une annexe est introuvable',
        ATTACHMENTS_TOO_LARGE: 'les pièces jointes dépassent 20 Mo',
        BILLING_MAIL_SEND_FAILED: 'le service de mails a refusé l’envoi',
        INVOICE_MAIL_FAILED: 'l’envoi a échoué',
        INVOICE_NOT_SENDABLE: {
          one: '{numbers} écartée, non envoyable',
          many: '{numbers} écartées, non envoyables',
        },
      },
      errors: {
        INVOICE_NUMBERS_INVALID: 'Cette sélection ne peut pas être envoyée : de 1 à 200 factures à la fois.',
        SCOPE_INVALID: 'Ce choix de factures n’est pas reconnu.',
        SCOPE_UNAVAILABLE: 'Ce choix n’est plus possible pour cette sélection : choisissez-en un autre.',
        PERIOD_MIXED: 'Les factures sélectionnées doivent être du même mois.',
        SCOPE_TOO_LARGE: 'Trop de factures pour un seul envoi : 300 factures et 30 entreprises au plus.',
        RECIPIENTS_INVALID: 'Un destinataire coché n’est plus un contact de facturation de son entreprise : fermez et rouvrez la fenêtre.',
        NOTHING_TO_SEND: 'Aucune facture envoyable n’a de destinataire coché.',
        REQUEST_ID_INVALID: 'Cet envoi n’a pas pu être identifié : fermez et rouvrez la fenêtre.',
        INVOICE_NOT_FOUND: 'Une facture de la sélection est introuvable.',
        SEND_IN_PROGRESS: 'Cet envoi est encore en cours : patientez, puis réessayez. Rien ne partira deux fois.',
        BILLING_MAIL_DISABLED: 'L’envoi de mails est coupé sur cet environnement.',
        BILLING_MAIL_TEMPLATE_MISSING: 'Le modèle du mail de facture manque sur cet environnement.',
        prepareFailed: 'Les factures et les contacts n’ont pas pu être chargés.',
        generic: 'L’envoi a échoué, réessayez.',
        network: 'Le serveur n’a pas répondu. Réessayez : un envoi déjà parti ne partira pas deux fois.',
      },
    },
    invoiceReminders: {
      tabCount: '{count} à faire',
      remindAll: 'Tout relancer',
      remindAllRunning: 'Relance en cours…',
      cards: {
        toDo: 'À faire',
        late: 'En retard',
        litigation: 'Contentieux',
        invoicesOne: '{count} facture',
        invoicesMany: '{count} factures',
        litigationValue: '{count} · {amount}',
        unknown: '—',
      },
      tabs: {
        label: 'Relances',
        todo: 'À faire',
        upcoming: 'À venir',
        litigation: 'Contentieux',
        settled: 'Réglées',
      },
      columns: {
        number: 'N°',
        company: 'Entreprise',
        remaining: 'Reste à payer',
        late: 'Retard',
        step: 'À envoyer',
        passage: 'Passage',
        status: 'Statut',
      },
      row: {
        invoiceOf: 'Facture {month}',
        noCompany: 'Sans entreprise',
        lateDaysOne: '{days} jour',
        lateDaysMany: '{days} jours',
        lateSince: 'depuis le {date}',
        notLate: 'Pas en retard',
        dueOn: 'échéance le {date}',
        nextOn: 'le {date}',
        remind: 'Relancer',
        open: 'Ouvrir',
        moreActions: 'Plus d’actions sur la facture {number}',
        suspend: 'Suspendre les relances',
        resume: 'Reprendre les relances',
      },
      badges: {
        before_due: 'Rappel',
        first: 'Relance 1/3',
        second: 'Relance 2/3',
        third: 'Relance 3/3',
        exhausted: 'Relances épuisées',
        noRecipient: 'Sans destinataire',
        suspended: 'Suspendue',
        uncertain: 'Envoi incertain',
        litigation: 'Contentieux',
      },
      badgeHints: {
        noRecipient: 'Aucun contact « Relances » dans l’entreprise : personne ne recevrait la relance.',
        suspended: 'Les relances automatiques de cette facture sont arrêtées.',
        uncertain: 'Un envoi est resté en cours plus de 10 minutes : vérifiez l’historique avant de relancer.',
      },
      suspension: {
        suspended: 'Relances automatiques suspendues pour la facture N°{number}.',
        resumedNext: 'Relances automatiques reprises pour la facture N°{number} : prochaine relance le {date}.',
        resumedNone: 'Relances automatiques reprises pour la facture N°{number} : aucune relance automatique n’est prévue.',
        errors: {
          INVOICE_NOT_REMINDABLE: 'Cette facture n’est plus relancée (réglée, annulée ou en contentieux) : la liste est relue.',
          INVOICE_NOT_FOUND: 'Cette facture est introuvable.',
          generic: 'Le changement n’a pas pu être enregistré, réessayez.',
        },
      },
      list: {
        loading: 'Chargement des relances…',
        loadFailed: 'La liste des relances n’a pas pu être chargée.',
        retry: 'Réessayer',
        showingRange: 'Affichage de {start}-{end} sur {total} résultats',
        showingAll: 'Affichage de {total} résultats',
        totalLate: 'Total en retard : {amount}',
        totalOwed: 'Total restant dû : {amount}',
        totalLitigation: 'Total en contentieux : {amount}',
        filteredEmptyTitle: 'Aucune facture ne correspond à cette recherche.',
        clearSearch: 'Effacer la recherche',
        empty: {
          todo: {
            title: 'Aucune facture à relancer',
            text: 'Les factures dont une relance est due apparaîtront ici.',
          },
          upcoming: {
            title: 'Aucune relance à venir',
            text: 'Les factures non réglées dont la prochaine relance n’est pas encore due apparaîtront ici.',
          },
          litigation: {
            title: 'Aucune facture en contentieux',
            text: 'Les factures confiées au contentieux apparaîtront ici.',
          },
          settled: {
            title: 'Aucune facture réglée après relance',
            text: 'Les factures payées après au moins une relance apparaîtront ici.',
          },
        },
      },
      remindAllModal: {
        title: 'Tout relancer',
        loading: 'Calcul des factures à relancer…',
        loadFailed: 'Les factures à relancer n’ont pas pu être comptées.',
        retryLoad: 'Réessayer',
        intro: 'Chaque facture d’« À faire » reçoit maintenant sa relance due, PDF joint, envoyée à ses contacts « Relances ».',
        countOne: '{count} facture sera relancée :',
        countMany: '{count} factures seront relancées :',
        nothing: 'Aucune facture d’« À faire » n’a de relance à envoyer.',
        step: '{label} : {count}',
        suspendedRule: 'Les factures suspendues ne sont pas relancées.',
        suspendedOne: '{count} facture suspendue ne sera pas relancée.',
        suspendedMany: '{count} factures suspendues ne seront pas relancées.',
        exhaustedOne: '{count} facture aux relances épuisées n’a plus de relance à envoyer.',
        exhaustedMany: '{count} factures aux relances épuisées n’ont plus de relance à envoyer.',
        triedRule: 'Une relance déjà tentée (en échec ou « Envoi incertain ») n’est pas renvoyée : relancez ces factures une par une.',
        cancel: 'Annuler',
        confirm: 'Tout relancer',
        starting: 'Lancement…',
        errors: {
          REMINDER_RUN_ALREADY_RUNNING: 'Un passage de relances est déjà en cours.',
          BILLING_MAIL_DISABLED: 'L’envoi de mails est coupé sur cet environnement.',
          BILLING_MAIL_TEMPLATE_MISSING: 'Le modèle du mail de relance manque sur cet environnement.',
          INVOICE_NUMBERS_INVALID: 'La liste des factures à relancer n’est pas valide.',
          generic: 'Le passage n’a pas pu être lancé, réessayez.',
        },
      },
      run: {
        alreadyRunning: 'Un passage de relances est déjà en cours : son compte rendu s’affichera à la fin.',
        done: 'Tout relancer : passage terminé',
        failed: 'Tout relancer : le passage s’est arrêté en échec',
        skipped: 'Tout relancer : le passage n’a pas eu lieu',
        counters: 'Envoyées : {sent} · échouées : {failed} · sans destinataire : {noRecipient} · déjà réglées : {settled} · déjà réservées : {alreadyClaimed}',
        lost: 'Le suivi du passage a été perdu : relisez la liste dans un moment.',
      },
      reminderModal: {
        title: 'Envoyer une relance',
        close: 'Fermer',
        summary: {
          number: 'N°{number}',
          remaining: 'reste à payer {amount}',
          lateOne: '{days} jour de retard',
          lateMany: '{days} jours de retard',
          dueOn: 'échéance le {date}',
        },
        loading: 'Préparation de la relance…',
        reload: 'Réessayer',
        recipientsLabel: 'Destinataires',
        recipients: {
          none: 'Aucun contact de facturation pour cette entreprise.',
          member: 'Membre',
          pendingMember: 'Invitation en attente',
          external: 'Externe',
          unnamed: 'Contact sans nom',
        },
        levelLabel: 'Modèle de relance',
        levels: {
          before_due: 'Rappel · Échéance proche',
          first: 'Relance 1/3 · Facture impayée',
          second: 'Relance 2/3 · Second rappel',
          third: 'Relance 3/3 · Mise en demeure amiable',
        },
        levelLoading: 'Chargement du modèle…',
        levelFailed: 'Ce modèle n’a pas pu être chargé : le précédent est gardé, réessayez.',
        messageLabel: 'Message',
        messageTooLong: 'Le message dépasse {max} caractères ({count} saisis).',
        attachment: 'La facture PDF est jointe automatiquement.',
        suspend: 'Suspendre les relances automatiques pour cette facture',
        nextAutomatic: 'Prochaine relance automatique prévue le {date}.',
        alreadySuspended: 'Les relances automatiques de cette facture sont déjà suspendues.',
        cancel: 'Annuler',
        send: 'Envoyer la relance',
        sending: 'Envoi en cours…',
        retrySend: 'Réessayer l’envoi',
        frozenNotice: 'La première tentative a peut-être abouti : la relance est figée. Réessayez l’envoi à l’identique ou fermez la fenêtre.',
        sent: 'Relance envoyée pour la facture N°{number}.',
        sentSuspended: 'Relance envoyée pour la facture N°{number} ; ses relances automatiques sont suspendues.',
        replayed: 'Cette relance de la facture N°{number} avait déjà été envoyée : rien n’a été renvoyé.',
        draftErrors: {
          INVOICE_NOT_REMINDABLE: 'Cette facture n’est pas relancée : réglée, annulée, avoir, sans échéance ou non importée.',
          INVOICE_IN_LITIGATION: 'Cette facture est en contentieux : sortez-la d’abord du contentieux pour la relancer.',
          INVOICE_NOT_FOUND: 'Cette facture est introuvable.',
          generic: 'La relance n’a pas pu être préparée.',
        },
        errors: {
          INVOICE_SETTLED: 'La facture a été réglée entre-temps : aucune relance n’est partie.',
          INVOICE_IN_LITIGATION: 'Cette facture est en contentieux : sortez-la d’abord du contentieux pour la relancer.',
          INVOICE_NOT_REMINDABLE: 'Cette facture n’est plus relancée (réglée, annulée ou sans échéance) : aucune relance n’est partie.',
          SEND_IN_PROGRESS: 'Cette relance est encore en cours d’envoi : patientez, puis réessayez. Rien ne partira deux fois.',
          LEVEL_INVALID: 'Ce modèle de relance n’est pas reconnu.',
          MESSAGE_INVALID: 'Le message doit compter de 1 à 5 000 caractères.',
          RECIPIENTS_INVALID: 'Un destinataire coché n’est plus un contact de facturation de l’entreprise : fermez et rouvrez la fenêtre.',
          REQUEST_ID_INVALID: 'Cet envoi n’a pas pu être identifié : fermez et rouvrez la fenêtre.',
          INVOICE_NOT_FOUND: 'Cette facture est introuvable.',
          MAIL_SEND_FAILED: 'Le mail de relance n’a pas pu partir : aucune relance n’a été envoyée. Vous pouvez réessayer, ce sera un nouvel envoi.',
          PENNYLANE_READ_FAILED: 'Le statut de la facture n’a pas pu être relu dans Pennylane : rien n’est parti. Réessayez dans un moment.',
          BILLING_MAIL_DISABLED: 'L’envoi de mails est coupé sur cet environnement.',
          BILLING_MAIL_TEMPLATE_MISSING: 'Le modèle du mail de relance manque sur cet environnement.',
          generic: 'L’envoi a échoué, réessayez.',
          network: 'Le serveur n’a pas répondu. Réessayez : une relance déjà partie ne partira pas deux fois.',
        },
      },
      detail: {
        remind: 'Envoyer une relance',
      },
      litigation: {
        bannerTitleOne: '{count} facture en contentieux',
        bannerTitleMany: '{count} factures en contentieux',
        bannerText: 'Les relances automatiques sont arrêtées. À transmettre pour recouvrement.',
        lastSent: '{label} le {date}',
        noneSent: 'Aucune relance envoyée',
        since: 'Depuis le {date}',
        start: 'Passer en contentieux',
        end: 'Sortir du contentieux',
        startModal: {
          title: 'Passer en contentieux',
          text: 'Passer la facture N°{number} en contentieux ? Les relances automatiques et manuelles s’arrêtent jusqu’à sa sortie.',
          cancel: 'Annuler',
          confirm: 'Passer en contentieux',
          pending: 'Passage en cours…',
          done: 'La facture N°{number} est passée en contentieux.',
        },
        endModal: {
          title: 'Sortir du contentieux',
          text: 'Sortir la facture N°{number} du contentieux ? Elle revient dans les relances, sans rattrapage : les relances déjà échues repassent dans « À faire » et attendent un admin.',
          cancel: 'Annuler',
          confirm: 'Sortir du contentieux',
          pending: 'Sortie en cours…',
          doneNext: 'La facture N°{number} est sortie du contentieux. Prochaine relance automatique prévue le {date}.',
          doneNone: 'La facture N°{number} est sortie du contentieux. Aucune relance automatique prévue.',
        },
        errors: {
          INVOICE_NUMBER_INVALID: 'Ce numéro de facture n’est pas valide.',
          INVOICE_NOT_FOUND: 'Cette facture est introuvable.',
          ALREADY_IN_LITIGATION: 'Cette facture est déjà en contentieux.',
          INVOICE_SETTLED: 'Cette facture est réglée ou annulée : elle ne peut pas passer en contentieux.',
          INVOICE_NOT_LATE: 'Cette facture n’est pas en retard : elle ne peut pas passer en contentieux.',
          NOT_IN_LITIGATION: 'Cette facture n’est plus en contentieux.',
          INVOICE_LITIGATION_FAILED: 'Le serveur n’a pas pu enregistrer le changement : rien n’a changé, réessayez.',
          forbidden: 'Vous n’avez pas accès aux factures.',
          generic: 'Le changement n’a pas pu être enregistré, réessayez.',
          network: 'Pas de réponse du serveur : le changement a peut-être été enregistré. La liste est relue.',
        },
      },
    },
    invoiceList: {
      tabInvoices: 'Factures clients',
      tabReminders: 'Rappels / Relances',
      importButton: 'Importer',
      columnNumber: 'N°',
      columnCompany: 'Entreprise',
      columnAmount: 'Montant TTC',
      columnRemaining: 'Reste à payer',
      columnStatus: 'Statut',
      besttClient: 'Client Bestt {id}',
      viewInvoice: 'Voir la facture',
      status: {
        error: 'Erreur',
        draft: 'Brouillon',
        pending: 'En attente',
        partiallyPaid: 'Partiellement payé',
        paid: 'Payé',
        cancelled: 'Annulée',
        notImported: 'Non importé',
      },
      late: 'En retard · {days} j',
      statusTooltip: {
        notImported: 'Pas encore récupérée depuis Bestt ni envoyée dans Pennylane.',
        draft: 'Importée dans Pennylane en brouillon, pas encore finalisée.',
        pending: 'Finalisée dans Pennylane, en attente de paiement.',
        partiallyPaid: '{paid} réglés · reste {remaining} à payer.',
        partiallyPaidPaidOnly: '{paid} réglés.',
        partiallyPaidRemainingOnly: 'Reste {remaining} à payer.',
        partiallyPaidUnknown: 'Réglée en partie.',
        paidOn: 'Réglée en totalité le {date}.',
        paid: 'Réglée en totalité.',
        late: 'Échéance du {date} dépassée.',
        lateNoDate: 'Échéance dépassée.',
        cancelled: 'Annulée dans Pennylane, exclue des montants à encaisser.',
        error: 'Import échoué : {cause}.',
        errorUnknown: 'Import échoué.',
        errorCauses: {
          ERR_BESTT_FACTURE_INTROUVABLE: 'Bestt ne connaît pas cette facture',
          ERR_BESTT_API: 'Bestt a échoué sur cette facture',
          ERR_ENTREPRISE_INCONNUE_JOBBIZ: 'aucune entreprise Jobbiz n’a ce client Bestt',
          ERR_ENTREPRISE_AMBIGUE_JOBBIZ: 'plusieurs entreprises Jobbiz ont ce client Bestt',
          ERR_BESTT_PDF_INDISPONIBLE: 'Bestt n’a pas rendu le PDF',
          ERR_STOCKAGE_PDF: 'le PDF n’a pas pu être rangé ou relu',
          ERR_PENNYLANE_DESACTIVE: 'hors production, rien n’est envoyé à Pennylane',
          ERR_ENTREPRISE_INTROUVABLE_PENNYLANE: 'aucun client Pennylane pour cette entreprise',
          ERR_ENTREPRISE_AMBIGUE_PENNYLANE: 'plusieurs clients Pennylane pour ce SIRET ou ce SIREN',
          ERR_TVA_TAUX_INCONNU: 'taux de TVA inconnu',
          ERR_PENNYLANE_API: 'Pennylane a refusé la facture ou n’a pas répondu',
        },
        errorSentences: {
          ERR_PENNYLANE_CATEGORIE: 'Facture importée, mais sa catégorie n’est pas posée.',
          ERR_PENNYLANE_ECHEANCE: 'Facture importée, mais son échéance n’est pas posée dans Pennylane.',
          ERR_PENNYLANE_ANNEXE: 'Facture importée, mais une annexe n’est pas envoyée dans Pennylane.',
        },
      },
      loadFailed: 'La liste des factures n’a pas pu être chargée.',
      retry: 'Réessayer',
      loading: 'Chargement des factures…',
      emptyTitle: 'Aucune facture pour {month}',
      emptyText: 'Les factures du mois apparaîtront ici dès qu’elles seront générées. Changez de mois ou modifiez vos filtres pour en voir d’autres.',
      seeMonth: 'Voir {month}',
      searchingTitle: 'Recherche des factures dans Bestt…',
      searchingText: 'La liste se met à jour d’elle-même.',
      searchingLine: 'Recherche de nouvelles factures dans Bestt…',
      showingRange: 'Affichage de {start}-{end} sur {total} résultats',
      showingAll: 'Affichage de {total} résultats',
      total: 'Total : {amount}',
      searchScopeLabel: 'Recherche dans',
      searchScope: {
        all: 'Tous',
        company: 'Entreprise',
        group: 'Groupe',
        number: 'N° de facture',
      },
      searchPlaceholder: 'Rechercher',
      filteredEmptyTitle: 'Aucune facture ne correspond à ces filtres.',
      clearFilters: 'Effacer les filtres',
      statusFilterLabel: 'Statut',
      statusFilter: {
        all: 'Tous les statuts',
        late: 'En retard',
      },
      selection: {
        selectPage: 'Sélectionner les factures de la page',
        selectInvoice: 'Sélectionner la facture {number}',
        barLabel: 'Actions sur la sélection',
        countOne: '1 facture sélectionnée',
        countMany: '{count} factures sélectionnées',
        retry: 'Réessayer',
        nothingToRetry: 'Plus aucune facture de la sélection n’est en erreur.',
        sendByMail: 'Envoyer par mail',
        exportCsv: 'Export CSV',
        exportTooMany: 'Exporter {max} factures au plus à la fois',
        exportFailed: 'L’export CSV n’a pas pu être fait, réessayez.',
        exportPeriodInvalid: 'Ce mois ne peut pas être exporté.',
        exportSelectionInvalid: 'Cette sélection ne peut pas être exportée.',
      },
      displayMode: {
        label: 'Affichage',
        all: 'Toutes les factures',
        byCompany: 'Par entreprise',
        byGroup: 'Par groupe',
      },
      grouping: {
        invoicesOne: '1 facture',
        invoicesMany: '{count} factures',
        companiesOne: '1 entreprise',
        companiesMany: '{count} entreprises',
        groupRowsOne: '1 groupe ou entreprise',
        groupRowsMany: '{count} groupes ou entreprises',
        groupLabel: 'Groupe',
        noGroup: 'Sans groupe',
        noCompany: 'Sans entreprise',
        unnamed: 'Sans nom',
        remainingPartial: 'Reste connu pour une partie des factures seulement',
        selectGroup: 'Sélectionner les factures de {name}',
        selectFailed: 'Les factures de {name} n’ont pas pu être sélectionnées, réessayez.',
        unfold: 'Déplier {name}',
        fold: 'Replier {name}',
        status: {
          errorOne: '1 en erreur',
          errorMany: '{count} en erreur',
          lateOne: '1 en retard',
          lateMany: '{count} en retard',
          notImportedOne: '1 non importée',
          notImportedMany: '{count} non importées',
          draftOne: '1 brouillon',
          draftMany: '{count} brouillons',
          pendingOne: '1 en attente',
          pendingMany: '{count} en attente',
          partiallyPaidOne: '1 partiellement payée',
          partiallyPaidMany: '{count} partiellement payées',
          paidOne: '1 payée',
          paidMany: '{count} payées',
          cancelledOne: '1 annulée',
          cancelledMany: '{count} annulées',
        },
      },
    },
    unreadApplications: {
      badgeOne: '1 nouvelle candidature depuis votre dernière visite',
      badgeOther: '{count} nouvelles candidatures depuis votre dernière visite',
      newTag: 'Nouveau',
    },
    inviteCandidates: {
      lastMission: 'Dernière mission :',
      alreadyInvited: 'Déjà invité',
    },
    missionCreation: {
      motifForm: {
        titles: {
          customaryContract: 'Contrat temporaire d’usage',
          replacement: 'Remplacement d’un salarié absent',
          activityIncrease: "Accroissement temporaire d'activité",
          awaitingRecruitment: 'En attente de recrutement',
          seasonal: 'Emploi à caractère saisonnier',
        },
        description: 'Votre description',
        maxLengthHint: '250 caractères',
        lengthError: 'Veuillez faire un message de plus de 10 caractères',
        name: 'Nom',
        firstname: 'Prénom',
        replacedPosition: 'Poste remplacé',
        absenceDescription:
          'Décrivez précisément le motif de l’absence de votre salarié.',
        date: 'Date',
        nameRequired: 'Veuillez indiquer un nom',
        firstnameRequired: 'Veuillez indiquer un prénom',
        positionRequired: 'Veuillez indiquer un poste',
        nameMissing: 'Un nom est requis',
        firstnameMissing: 'Un prénom est requis',
        dateMissing: 'Une date est requise',
        cancel: 'Annuler',
        confirm: 'Confirmer',
      },
    },
    missionTemplate: {
      createTitle: "Création d'une fiche de poste",
      editTitle: "Modification d'une fiche de poste",
      saveButton: 'Enregistrer la fiche',
      steps: {
        activity: "Secteur d'activité",
        risk: 'Poste à risque',
        prerequis: 'Prérequis',
        tasks: 'Tâches',
        locationSalary: 'Lieu & rémunération',
        confirmation: 'Confirmation',
      },
      dressCode: {
        label: 'Tenue vestimentaire',
        placeholder: 'Ex : pantalon noir, haut blanc uni, chaussures de sécurité',
        tooLong: 'La tenue vestimentaire ne doit pas dépasser 500 caractères',
      },
      tasks: {
        title: 'Tâches du poste',
        description: 'Cochez les tâches proposées ou ajoutez les vôtres.',
        addPlaceholder: 'Ajouter une tâche (ex : accueil des livreurs)',
        addButton: 'Ajouter',
        selectedCountOne: '{count} tâche',
        selectedCountOther: '{count} tâches',
        selectedOfOne: 'sélectionnée sur {total}',
        selectedOfOther: 'sélectionnées sur {total}',
        addedByCompany: 'Ajoutée par vous',
        noProposal:
          "Aucune tâche proposée pour cette qualification. Ajoutez celles de l'intérimaire.",
        duplicate: 'Cette tâche est déjà dans la liste.',
        remove: 'Retirer {label}',
        removeTooltip: 'Retirer',
        required: 'Veuillez retenir au moins une tâche',
        checking: 'Vérification en cours',
        rejected:
          "« {label} » n'a pas été ajoutée : ce texte ne décrit pas une tâche du poste.",
        checkingBeforeSave: 'Vérification des tâches…',
        existingChecked: '« {match} » existe déjà : elle a été cochée.',
        existingListed:
          "« {match} » existe déjà dans la liste : elle n'a pas été ajoutée.",
        addAsNewTask: 'Ajouter comme nouvelle tâche',
        closeNotice: 'Fermer',
        notCheckedTooLong:
          "« {label} » n'a pas pu être vérifiée : ajoutez les tâches une par une (80 caractères au plus).",
      },
      responsible: {
        title: 'Responsable sur place',
        description: "La personne que l'intérimaire contactera en arrivant.",
      },
      confirmation: {
        title: 'Tout est bon ?',
        description:
          "Relisez la fiche avant de l'enregistrer. Vous pourrez la modifier plus tard.",
        edit: 'Modifier : {label}',
      },
      summary: {
        name: 'Intitulé',
        activity: 'Secteur',
        qualification: 'Qualification',
        riskyPosition: 'Poste à risque',
        tools: 'Matériel',
        licences: 'Permis',
        languages: 'Langue',
        dressCode: 'Tenue vestimentaire',
        address: 'Adresse',
        salary: 'Taux horaire brut',
        contact: 'Responsable',
        tasks: 'Tâches',
      },
      format: {
        none: 'Aucun',
        noTask: 'Aucune',
        dressCodeMissing: 'Non renseignée',
        riskNo: 'Non',
        riskYes: 'Oui',
        riskYesWith: 'Oui · {factors}',
        rate: '{rate} €',
        rateIndexed: '{rate} € · indexé au SMIC',
        contact: '{name} · {poste}',
        tasksTwo: '{first} et {second}',
        tasksMoreOne: '{first}, {second} et 1 autre',
        tasksMoreOther: '{first}, {second} et {count} autres',
      },
      mission: {
        instructionsTitle: 'Consignes',
        instructionsDescription:
          'Propres à cette mission, elles ne modifient pas la fiche de poste.',
        instructionsInterim: "Pour l'intérimaire",
        instructionsInterimPlaceholder:
          "Ex : arrivez 15 min en avance et demandez William à l'accueil",
        instructionsJobbiz: "Pour l'équipe Jobbiz",
        instructionsJobbizPlaceholder: 'Ex : profil autonome souhaité',
        summaryInterim: 'Consignes intérimaire',
        summaryJobbiz: 'Consignes Jobbiz',
        noInstructions: 'Aucune',
      },
    },
    qualification: {
      list: {
        name: 'Nom du poste',
        tasks: 'Tâches',
        sector: 'Secteur',
        createdAt: 'Créé le',
        disabled: 'Désactivé',
        notInBestt: "La mission n'a pas été référencée sur BeSTT",
        tasksCountOne: '{count} tâche',
        tasksCountOther: '{count} tâches',
        tasksCountZero: '0 tâche',
        noTasksWarning:
          "Aucune tâche : les fiches de poste de ce poste n'en proposeront pas",
        create: 'Créer une qualification',
      },
      slideOver: {
        createTitle: 'Créer une qualification',
        close: 'Fermer',
        editTitle: 'Modifier une qualification',
        subtitle:
          'Le poste aura son propre vivier et sera proposé à la création de missions.',
        editSubtitle:
          'Fiche du poste visible par les intérimaires. Elle définit aussi le vivier associé.',
        editTasksSubtitle:
          "Tâches proposées à l'entreprise quand elle crée une mission pour ce poste. Elle peut en retirer ou en ajouter.",
        tabInformations: 'Informations',
        tabTasks: 'Tâches',
        tabTasksWithCount: 'Tâches ({count})',
        tabRisk: 'Poste à risque',
        tabRequirements: 'Prérequis',
        editRiskSubtitle:
          'Indiquez si le poste est à risque et les facteurs concernés. Ils seront repris dans le contrat de mission.',
        editRequirementsSubtitle:
          'Matériel, EPI, permis et CACES nécessaires pour ce poste. Ils sont repris par défaut dans les missions.',
        name: 'Nom du poste',
        nameLocked: "Le nom n'est plus modifiable après la création",
        description: 'Description',
        descriptionHint:
          "Présentez le poste et son contexte. Les tâches se gèrent dans l'onglet Tâches.",
        pcs: 'PCS',
        rome: 'ROME',
        sector: 'Secteur',
        sectorPlaceholder: 'Choisir un secteur',
        sectors: {
          sale: 'Vente',
          logistic: 'Logistique',
          food: 'Restauration',
          largeDistribution: 'Grande distribution',
          administration: 'Administration',
          industry: 'Industrie',
          other: 'Autre',
        },
        missionPreferences: 'Afficher dans « Préférences de missions »',
        missionPreferencesHelp:
          "L'intérimaire pourra ajouter ce poste à sa liste de souhaits.",
        deactivate: 'Désactiver',
        activate: 'Activer',
        cancel: 'Annuler',
        confirm: 'Confirmer',
        confirming: 'Confirmation ...',
        created: 'La qualification a bien été créée.',
        updated: 'La qualification a bien été modifiée.',
        deactivated: 'La qualification a bien été désactivée.',
        activated: 'La qualification a bien été activée.',
        missingFields: 'Veuillez remplir tous les champs.',
        requiredField: 'Champ obligatoire',
        errorInvalidTasks:
          'Les tâches ont été refusées : vérifiez les libellés (80 caractères au plus), les doublons et le nombre de tâches (50 au plus).',
        errorNameImmutable: "Le nom n'est plus modifiable après la création.",
        nameWillLock: 'Le nom ne sera plus modifiable après la création',
        create: 'Créer',
        errorInvalidPcs:
          "Le code PCS est refusé : il doit compter 3 chiffres suivis d'une lettre (ex. 553C).",
        errorInvalidRome:
          'Le code ROME est refusé : il doit être une lettre de A à N suivie de 4 chiffres (ex. N1105), et exister dans le référentiel ROME.',
        errorInvalidAiSuggestion:
          "La proposition de l'IA n'est plus valable. Vérifiez les champs puis cliquez à nouveau sur « Créer » : la qualification sera créée sans elle.",
        warningPcsNotInList:
          "Le code PCS n'appartient pas à la nomenclature PCS-ESE 2017. Il a été enregistré : vérifiez-le.",
        errorRiskFactorRequired:
          "Sélectionnez au moins un facteur de risque, ou indiquez que le poste n'est pas à risque.",
        errorRiskFactorUnknown:
          "Le facteur de risque « {name} » n'existe pas dans la liste. Décochez-le puis enregistrez à nouveau.",
        errorRiskFactorUnknownGeneric:
          "Un facteur de risque coché n'existe pas dans la liste. Vérifiez les facteurs puis enregistrez à nouveau.",
        errorToolUnknown:
          "L'EPI « {name} » n'existe pas dans la liste du matériel. Retirez-le puis enregistrez à nouveau.",
        errorToolUnknownGeneric:
          "Un EPI choisi n'existe pas dans la liste du matériel. Vérifiez les EPI puis enregistrez à nouveau.",
        errorLicenceUnknown:
          "Le permis « {name} » n'existe pas dans la liste des permis. Retirez-le puis enregistrez à nouveau.",
        errorLicenceUnknownGeneric:
          "Un permis choisi n'existe pas dans la liste des permis. Vérifiez les permis puis enregistrez à nouveau.",
      },
      tasks: {
        newTask: 'Nouvelle tâche',
        newTaskPlaceholder: 'Ex. : Nettoyer la zone de quai',
        add: 'Ajouter',
        empty:
          "Aucune tâche pour ce poste. Ajoutez-en ou utilisez l'IA pour en proposer.",
        errorEmpty: 'Saisissez un libellé.',
        errorTooLong: 'Le libellé ne doit pas dépasser {max} caractères.',
        errorDuplicate: 'Cette tâche est déjà dans la liste.',
        limitReached: '{max} tâches au plus par poste.',
        editLabel: 'Libellé de la tâche',
        edit: 'Modifier {label}',
        drag: 'Déplacer {label}',
        remove: 'Supprimer {label}',
        editTooltip: 'Modifier',
        dragTooltip: 'Déplacer',
        removeTooltip: 'Supprimer',
        removeUsedOne:
          'Cette tâche est utilisée dans 1 fiche de poste. Elle restera sur cette fiche mais ne sera plus proposée.',
        removeUsedOther:
          'Cette tâche est utilisée dans {count} fiches de poste. Elle restera sur ces fiches mais ne sera plus proposée.',
        renameUsedOne:
          'Le nouveau libellé sera repris dans la fiche de poste qui utilise cette tâche.',
        renameUsedOther:
          'Le nouveau libellé sera repris dans les {count} fiches de poste qui utilisent cette tâche.',
        confirmRemove: 'Supprimer',
        confirmRename: 'Renommer',
        cancel: 'Annuler',
        dragRoleDescription: 'élément déplaçable',
        dragInstructions:
          'Pour déplacer une tâche, appuyez sur Espace ou Entrée, utilisez les flèches haut et bas, puis Espace ou Entrée pour la déposer, ou Échap pour annuler.',
        dragStart: 'Tâche {label} saisie.',
        dragOver: 'Tâche {label} déplacée sur {over}.',
        dragEnd: 'Tâche {label} déposée.',
        dragCancel: 'Déplacement de la tâche {label} annulé.',
      },
      risk: {
        question: 'Ce poste est-il à risque ?',
        articleLink: "Voir l'article L. 4154-2 du Code du travail",
        factorsLegend: 'Facteurs de risque concernés',
        loading: 'Chargement des facteurs de risque…',
        listError:
          'Impossible de charger la liste des facteurs de risque. Fermez puis rouvrez le panneau pour réessayer.',
        empty: 'Aucun facteur de risque dans la liste.',
      },
      requirements: {
        tools: 'EPI',
        toolsPlaceholder: 'Ajouter du matériel',
        licences: 'Permis',
        licencesPlaceholder: 'Ajouter un permis ou un CACES',
        search: 'Rechercher',
        noResult: 'Aucun résultat',
        remove: 'Retirer {name}',
        removeTooltip: 'Retirer',
        loading: 'Chargement…',
        toolsListError:
          'Impossible de charger la liste du matériel. Les EPI déjà choisis restent enregistrés.',
        licencesListError:
          'Impossible de charger la liste des permis. Les permis déjà choisis restent enregistrés.',
      },
      ai: {
        useAi: "Pré-remplir avec l'IA",
        useAiHelp: "L'IA remplit à partir du nom du poste :",
        generate: 'Créer et générer',
        continue: 'Continuer',
        titleLength:
          "Pour l'IA, le nom du poste doit compter entre {min} et {max} caractères.",
        generatingTitle: "L'IA prépare la fiche du poste",
        generatingButton: 'Génération…',
        counterLabel: 'Étapes terminées : {done} sur {total}',
        steps: {
          description: 'Description',
          sector: 'Secteur',
          tasks: 'Tâches par défaut',
          codes: 'Codes PCS et ROME',
          requirements: 'Poste à risque et prérequis',
        },
        stepTitles: {
          description: 'Description rédigée',
          sector: 'Secteur identifié',
          tasks: 'Tâches par défaut',
          codes: 'Codes PCS et ROME',
          requirements: 'Poste à risque et prérequis',
        },
        stepDone: 'Terminé',
        stepPending: 'En cours…',
        stepWaiting: 'En attente',
        stepRome: 'ROME {code}',
        stepPcs: 'PCS {code}',
        stepSentencesOne: '1 phrase sur le poste et son contexte',
        stepSentencesOther: '{count} phrases sur le poste et son contexte',
        stepTasksZero: 'Aucune tâche proposée',
        stepTasksOne: '1 tâche proposée',
        stepTasksOther: '{count} tâches proposées',
        stepNotAtRisk: 'Pas à risque',
        stepFactorsOne: '1 facteur de risque',
        stepFactorsOther: '{count} facteurs de risque',
        stepToolsOne: '1 EPI',
        stepToolsOther: '{count} EPI',
        stepLicencesOne: '1 permis',
        stepLicencesOther: '{count} permis',
        prefilled: "Pré-rempli par l'IA, à vérifier avant de créer.",
        regenerate: 'Re-générer',
        badge: "Suggéré par l'IA",
        markLabel: 'IA',
        failed:
          'Impossible de proposer une qualification, remplissez les champs manuellement.',
        lowConfidence: {
          rome: 'Confiance faible sur le code ROME proposé : vérifiez-le ou choisissez une alternative.',
          pcs: 'Confiance faible sur le code PCS proposé : vérifiez-le ou choisissez une alternative.',
        },
        alternative: '{code} — {label}',
        similarTitle: 'Des qualifications proches existent déjà',
        similarHelp:
          "Vérifiez qu'elle n'existe pas avant d'en créer une nouvelle.",
        similarDisabled: 'Désactivée',
        alternativeName: 'Autre nom proposé : {name}',
        useAlternativeName: 'Utiliser',
      },
      regenerate: {
        button: "Regénérer avec l'IA",
        loading: 'Chargement de la qualification…',
        before: 'Avant :',
        suggested: "Suggestion de l'IA :",
        restore: 'Rétablir',
        reapply: 'Remettre la suggestion',
        restoreField: 'Rétablir la valeur précédente : {field}',
        reapplyField: "Remettre la suggestion de l'IA : {field}",
        emptyValue: 'Non renseigné',
        notAtRisk: 'Pas à risque',
        atRisk: 'À risque',
        summary:
          "Modifié par l'IA : {fields}. Vérifiez puis confirmez pour enregistrer.",
        summaryNone: "L'IA n'a proposé aucun changement.",
      },
    },
    missionActivity: {
      perimeterChange: {
        title: 'a changé le périmètre',
        field: 'Périmètre',
        none: 'Aucun',
        unnamed: 'Sans nom',
        reasons: {
          manual: 'depuis la fiche de la mission',
          archive_transfer: 'archivage du périmètre d’origine',
          duplicate: 'copie d’une mission d’un périmètre archivé',
        },
      },
    },
    companyContacts: {
      tabLabel: 'Contacts',
      registered: {
        title: 'Inscrit sur Jobbiz',
        add: 'Ajouter',
        pending: 'En attente',
        resendInvitation: 'Renvoyer l’invitation',
        edit: 'Modifier le contact',
        remove: 'Retirer de l’entreprise',
        missingAccount: 'Compte introuvable',
        removeMissingAccount: 'Retirer le compte introuvable',
      },
      hubspot: {
        title: 'Contacts HubSpot',
        description:
          'Contacts de {company} dans HubSpot qui n’ont pas encore de compte Jobbiz.',
        refresh: 'Actualiser les contacts HubSpot',
        collapse: 'Replier les contacts HubSpot',
        expand: 'Déplier les contacts HubSpot',
        invite: 'Inviter',
        error: 'Les contacts HubSpot n’ont pas pu être chargés.',
        retry: 'Réessayer',
      },
      perimeters: {
        title: 'Périmètres',
        description:
          'Limite l’accès des managers aux missions, contrats et relevés d’heures. Sans périmètre, un membre voit tout.',
        allMissions: 'Toutes les missions',
        collapse: 'Replier les périmètres',
        expand: 'Déplier les périmètres',
        list: {
          loadError: 'Les périmètres n’ont pas pu être chargés.',
          retry: 'Réessayer',
          create: 'Créer',
          edit: 'Modifier',
          archive: 'Archiver',
          members: {
            one: '{count} membre',
            many: '{count} membres',
          },
          noMembers: 'Aucun membre rattaché',
        },
        empty: {
          title: 'Aucun périmètre pour l’instant',
          description:
            'Sans périmètre, tous les managers voient toutes les missions, contrats et relevés d’heures. Créez des périmètres (un service, un site, une équipe...) pour limiter leurs accès.',
        },
        form: {
          createTitle: 'Créer un périmètre',
          createDescription:
            'Rattachez les membres qui géreront les missions de ce périmètre. Les membres sans périmètre continuent de tout voir.',
          nameLabel: 'Nom du périmètre',
          namePlaceholder: 'Ex. Cuisine, Site du Lamentin, Équipe de nuit',
          membersLabel: 'Membres rattachés (optionnel)',
          searchPlaceholder: 'Rechercher un membre',
          noAssignableMember: 'Aucun membre à rattacher pour le moment.',
          noSearchResult: 'Aucun membre ne correspond à votre recherche.',
          create: 'Créer',
          creating: 'Création…',
          editTitle: 'Modifier « {name} »',
          editDescription:
            'Les changements s’appliquent tout de suite aux accès des membres.',
          save: 'Enregistrer',
          saving: 'Enregistrement…',
        },
        modal: {
          cancel: 'Annuler',
        },
        delete: {
          title: 'Supprimer « {name} » ?',
          description:
            'Ce périmètre n’est rattaché à aucune mission. Il sera supprimé définitivement.',
          confirm: 'Supprimer',
          deleting: 'Suppression…',
        },
        archive: {
          title: 'Archiver « {name} » ?',
          transferTitle: 'Archiver « {name} »',
          finishedMissions: {
            one: 'La mission terminée garde ce périmètre dans son historique.',
            many: 'Les {count} missions terminées gardent ce périmètre dans leur historique.',
          },
          notProposed:
            'Il ne sera plus proposé pour les nouvelles missions et vous pourrez le restaurer à tout moment.',
          activeMissions: {
            one: '{count} mission en cours ou à venir',
            many: '{count} missions en cours ou à venir',
          },
          transferIntro:
            '{missions} et {members} sont rattachés à ce périmètre. Les missions terminées le gardent dans leur historique.',
          transferLabel: 'Transférer les missions et les membres vers',
          noPerimeter: 'Aucun périmètre',
          confirm: 'Archiver',
          archiving: 'Archivage…',
          usageError:
            'Impossible de vérifier les accès des membres concernés.',
        },
        restore: {
          title: 'Restaurer « {name} » ?',
          description: {
            one: 'Ce périmètre revient sans membre. Sa mission terminée lui sera de nouveau réservée : tant que vous n’y rattachez pas de membres, seuls les administrateurs, les directeurs et les membres sans périmètre la verront.',
            many: 'Ce périmètre revient sans membre. Ses {count} missions terminées lui seront de nouveau réservées : tant que vous n’y rattachez pas de membres, seuls les administrateurs, les directeurs et les membres sans périmètre les verront.',
          },
          restoring: 'Restauration…',
        },
        alert: {
          membersAccess: {
            one: 'Le membre concerné aura accès à toutes les missions, contrats et relevés d’heures.',
            many: 'Les {count} membres concernés auront accès à toutes les missions, contrats et relevés d’heures.',
          },
        },
        archived: {
          heading: 'Archivés ({count})',
          archivedOn: 'Archivé le {date}',
          finishedMissions: {
            one: '{count} mission terminée',
            many: '{count} missions terminées',
          },
          restore: 'Restaurer',
          loadError: 'Les périmètres archivés n’ont pas pu être chargés.',
        },
        toast: {
          created: 'Périmètre créé',
          updated: 'Périmètre modifié',
          archived: 'Périmètre archivé',
          deleted: 'Périmètre supprimé',
          transferred: {
            one: '{count} mission transférée vers {name}',
            many: '{count} missions transférées vers {name}',
          },
          archivedNoPerimeter: {
            one: 'Périmètre « {name} » archivé · {count} mission n’a plus de périmètre',
            many: 'Périmètre « {name} » archivé · {count} missions n’ont plus de périmètre',
          },
          restored: 'Périmètre « {name} » restauré',
        },
        member: {
          restricted: 'Voit uniquement les missions de ces périmètres.',
          none: 'Aucun : voit toutes les missions.',
          unrestricted: 'Voit toujours toutes les missions',
          add: 'Ajouter des périmètres',
          remove: 'Retirer « {name} »',
          loading: 'Chargement des périmètres…',
          loadError:
            'Les périmètres n’ont pas pu être chargés : ils ne seront pas modifiés.',
          saveFailed:
            'Contact enregistré, mais ses périmètres n’ont pas été modifiés. {reason}',
          addModal: {
            title: 'Ajouter des périmètres',
            description:
              'Choisissez les périmètres de {company} auxquels rattacher {name}.',
            searchPlaceholder: 'Rechercher un périmètre',
            noPerimeterLeft: 'Aucun autre périmètre actif à proposer.',
            noSearchResult: 'Aucun périmètre ne correspond à votre recherche.',
            confirm: 'Confirmer',
          },
          errors: {
            notRestrictable:
              'Un directeur ou un administrateur voit toujours toutes les missions : ses périmètres ne se modifient pas.',
            notFound:
              'Un des périmètres choisis n’existe plus : la liste a été actualisée.',
            archived:
              'Un des périmètres choisis vient d’être archivé : la liste a été actualisée.',
            notLoaded:
              'La liste des périmètres n’a pas pu être relue : réessayez dans un instant.',
          },
        },
        errors: {
          generic: 'Une erreur est survenue. Veuillez réessayer.',
          nameRequired: 'Le nom du périmètre est obligatoire.',
          nameTooLong: 'Ce nom est trop long.',
          nameTaken: 'Un périmètre porte déjà ce nom (actif ou archivé).',
          memberInvalid:
            'Ce membre n’est plus disponible : la liste a été actualisée.',
          notFound: 'Ce périmètre n’existe plus.',
          archived:
            'Ce périmètre est archivé : restaurez-le avant de le modifier.',
          alreadyArchived: 'Ce périmètre est déjà archivé.',
          notArchived: 'Ce périmètre n’est plus archivé.',
          inUse:
            'Ce périmètre a déjà été rattaché à une mission : il ne peut plus être supprimé, seulement archivé.',
          transferInvalid:
            'Le périmètre choisi n’est plus disponible pour le transfert.',
          companyNotFound: 'Cette entreprise n’existe plus.',
        },
      },
      roles: {
        200: {
          label: 'Observateur',
          description:
            'L’observateur peut uniquement consulter l’ensemble des factures, relevés d’heures, contrats et missions créés par l’entreprise.',
        },
        205: {
          label: 'Manageur',
          description:
            'Le manager peut uniquement vérifier des relevés d’heures.',
        },
        210: {
          label: 'Responsable',
          description:
            'Le responsable peut signer des contrats, importer des factures, vérifier des relevés d’heures, et créer des missions.',
        },
        215: {
          label: 'Directeur',
          description:
            'Le directeur peut signer des contrats, importer des factures, vérifier des relevés d’heures, et créer des missions et modifier le profil de l’entreprise.',
        },
        220: {
          label: 'Superviseur',
          description:
            'Le superviseur peut créer des missions et vérifier des relevés d’heures.',
        },
        225: {
          label: 'Administrateur',
          description:
            'L’administrateur a tous les droits du directeur ; il gère aussi l’équipe et ses permissions, et reçoit les rappels de l’entreprise.',
        },
      },
      edit: {
        back: 'Retour aux contacts',
        title: 'Modifier le contact',
        subtitle: 'Informations, périmètres et notifications de ce contact',
        firstName: 'Prénom',
        lastName: 'Nom',
        email: 'E-mail',
        role: 'Rôle',
        cancel: 'Annuler',
        save: 'Enregistrer',
        saving: 'Enregistrement…',
        saved: 'Contact enregistré.',
        savedInvitationFailed:
          'Contact enregistré, mais l’invitation n’a pas pu partir. Renvoyez-la depuis la liste des contacts.',
        pendingEmailChange: 'L’invitation sera renvoyée à la nouvelle adresse.',
        activeEmailHint:
          'La nouvelle adresse devient aussitôt son identifiant de connexion ; aucun e-mail ne l’en prévient.',
        lastAdminWarning:
          'L’entreprise n’aura plus d’administrateur : les rappels et plusieurs mails de l’entreprise ne partiront plus à personne.',
        errors: {
          required: 'Ce champ est requis.',
          nameTooLong: '35 caractères au plus.',
          emailInvalid: 'Adresse e-mail invalide.',
          emailTaken: 'Cette adresse est déjà utilisée par un autre compte.',
          adminTaken: '{name} est déjà administrateur de cette entreprise.',
          adminTakenByMissingAccount:
            'Un compte introuvable occupe déjà le rôle Administrateur. Retirez-le de la liste avant d’en nommer un autre.',
          adminTakenUnknown:
            'Un autre membre est déjà administrateur de cette entreprise.',
          memberNotFound: 'Ce membre ne fait plus partie de l’entreprise.',
          generic:
            'Une erreur est survenue, veuillez réessayer ou contacter le support.',
        },
        notifications: {
          title: 'Notifications',
          name: 'Nom',
          perimeter: 'Périmètre',
          all: 'Tout',
          checkboxLabel: '{type} : {column}',
          loading: 'Chargement des notifications…',
          loadError:
            'Les notifications n’ont pas pu être chargées : elles ne seront pas modifiées.',
          retry: 'Réessayer',
          unrestrictedHint:
            'Un directeur ou un administrateur est prévenu pour toutes les missions : la colonne Périmètre ne s’applique pas.',
          noPerimeterHint:
            'Ce contact n’a aucun périmètre : « Périmètre » vaut « Tout » jusqu’à ce qu’il soit rattaché à un périmètre.',
          types: {
            invoices: {
              label: 'Facture',
              description: 'Nouvelle facture émise',
            },
            reminders: {
              label: 'Relances factures',
              description: 'Rappels d’échéances et relances d’impayés',
            },
            contracts: {
              label: 'Contrats',
              description: 'Nouveaux contrats à signer',
            },
            timesheets: {
              label: 'Relevés d’heures',
              description: 'Relevés d’heures à vérifier',
            },
            missions: {
              label: 'Missions',
              description: 'Affectation, annulation et fin des missions',
            },
          },
          saveFailed:
            'Contact enregistré, mais ses notifications n’ont pas été modifiées. {reason}',
          errors: {
            generic: 'Une erreur est survenue. Veuillez réessayer.',
            forbidden:
              'Votre compte n’a pas le droit de modifier les notifications de ce contact.',
            companyNotFound: 'Cette entreprise est introuvable.',
            memberInvalid: 'Ce contact est introuvable.',
            typeInvalid:
              'Un des sujets envoyés n’est pas reconnu : rechargez la fiche puis réessayez.',
            levelInvalid:
              'Le niveau Périmètre ne s’applique ni aux factures, ni à un directeur ou un administrateur : vérifiez les notifications.',
          },
        },
      },
      removal: {
        lastAdminWarning:
          'Ce membre est l’administrateur de l’entreprise : sans lui, les rappels et plusieurs mails de l’entreprise ne partiront plus à personne.',
        missingAccountConfirm:
          'Retirer ce compte introuvable de l’entreprise ?',
      },
      resend: {
        alreadyActive:
          'Ce membre a déjà activé son compte : l’invitation n’est plus nécessaire.',
        failed: 'L’invitation n’a pas pu être renvoyée, veuillez réessayer.',
      },
      invite: {
        title: 'Inviter sur Jobbiz',
        description: '{name} recevra un e-mail pour créer son compte.',
        hubspotDescription:
          '{name} recevra un e-mail pour créer son compte. Ses informations viennent de HubSpot.',
        someone: 'La personne invitée',
        email: 'E-mail',
        firstName: 'Prénom',
        lastName: 'Nom',
        phone: 'Numéro (optionnel)',
        role: 'Rôle',
        cancel: 'Annuler',
        send: 'Envoyer l’invitation',
        sending: 'Envoi…',
        sent: 'Invitation envoyée.',
        attached: 'Compte existant rattaché à l’entreprise.',
        sentMailFailed:
          'Contact ajouté, mais l’invitation n’a pas pu partir. Renvoyez-la depuis la liste des contacts.',
        attachedMailFailed:
          'Compte rattaché, mais l’e-mail qui l’en prévient n’a pas pu partir.',
        errors: {
          phoneInvalid: 'Numéro invalide.',
          alreadyMember: 'Cette personne fait déjà partie de l’entreprise.',
          tempWorker: 'Cette adresse appartient à un compte intérimaire.',
          companyNotFound: 'Cette entreprise n’existe plus.',
        },
        perimeters: {
          steps: 'Étapes de l’invitation',
          information: 'Information',
          notifications: 'Notifications',
          next: 'Suivant',
          label: 'Périmètres',
          none: 'Aucun · toutes les missions',
          unrestricted: 'Voit toujours toutes les missions',
          empty: 'Aucun périmètre actif.',
          loadError:
            'Les périmètres de l’entreprise n’ont pas pu être chargés : sans périmètre, la personne invitée verra toutes les missions.',
          reloadError:
            'La liste des périmètres n’a pas pu être relue : elle peut encore proposer un périmètre qui n’existe plus.',
          retry: 'Réessayer',
          errors: {
            notRestrictable:
              'Un directeur ou un administrateur voit toujours toutes les missions : il ne peut pas être rattaché à un périmètre.',
            notFound:
              'Un des périmètres choisis n’existe plus : la liste a été actualisée. L’invitation n’est pas partie.',
            archived:
              'Un des périmètres choisis vient d’être archivé : la liste a été actualisée. L’invitation n’est pas partie.',
          },
        },
        notifications: {
          noPerimeterHint:
            'Sans périmètre, « Périmètre » vaut « Tout » : ce contact sera prévenu de ses seuls périmètres dès qu’il en aura un.',
          errors: {
            typeInvalid:
              'Un des sujets de notification n’est pas reconnu : rechargez la page puis réessayez. L’invitation n’est pas partie.',
            levelInvalid:
              'Le niveau Périmètre ne s’applique ni aux factures, ni à un directeur ou un administrateur : vérifiez les notifications. L’invitation n’est pas partie.',
          },
        },
      },
      activity: {
        emptyTitle: 'Aucune modification enregistrée',
        emptyText:
          'Les modifications apportées à cette entreprise apparaîtront ici.',
        hubspot: {
          updated: 'HubSpot mis à jour',
          notFound: 'Aucun contact HubSpot avec cette adresse',
          failed: 'Échec de la mise à jour HubSpot',
        },
        invitation: {
          resent: 'Invitation renvoyée à la nouvelle adresse',
          failed: 'L’invitation n’a pas pu être renvoyée',
          fromHubspot: 'Depuis HubSpot',
          notSent: 'L’e-mail n’a pas pu partir',
        },
      },
    },
    companyBilling: {
      cardTitle: 'Informations de facturation',
      billingAddress: 'Adresse de facturation',
      paymentTerm: 'Délai de paiement',
      notSet: 'Non renseigné',
      loadError: 'Les informations de facturation n’ont pas pu être chargées.',
      modalTitle: 'Informations de facturation',
      modalIntro:
        'S’appliquent à toutes les factures de l’entreprise. Une facture peut avoir un délai différent, depuis son détail.',
      companyAddressHint: 'Adresse de l’entreprise',
      companyAddressPrefix: 'Adresse de l’entreprise : {address}',
      noCompanyAddress: 'L’entreprise n’a pas d’adresse.',
      restore: 'Rétablir',
      paymentTermPlaceholder: 'Choisir un délai',
      currentPaymentTerm: 'Actuellement : {term}',
      defaultPaymentTerm: '{term} · par défaut',
      cancel: 'Annuler',
      save: 'Enregistrer',
      saving: 'Enregistrement…',
      saved: 'Informations de facturation enregistrées.',
      savedBesttFailed:
        'Enregistré, mais BeSTT n’a pas été mis à jour : les factures imprimeront l’ancienne adresse.',
      besttNotUpdated: 'BeSTT n’a pas été mis à jour',
      errors: {
        BILLING_ADDRESS_INVALID: 'Adresse incomplète : rue, code postal à 5 chiffres et ville.',
        PAYMENT_TERM_INVALID: 'Délai de paiement invalide.',
        COMPANY_NOT_FOUND: 'Entreprise introuvable.',
        generic: 'Une erreur est survenue, réessayez.',
      },
      paymentTerms: {
        onReceipt: 'À réception',
        days15: '15 jours',
        days30: '30 jours',
        days30EndOfMonth: '30 jours fin de mois',
        days45: '45 jours',
        days45EndOfMonth: '45 jours fin de mois',
        days60: '60 jours',
      },
    },
    companyOverview: {
      address: 'Adresse',
    },
    companyBillingHistory: {
      cardTitle: 'Historique de facturation',
      previousYear: 'Année précédente',
      nextYear: 'Année suivante',
      columnPeriod: 'Période',
      columnNumber: 'N°',
      columnAmount: 'Montant TTC',
      columnPayment: 'Paiement',
      openInvoice: 'Voir la facture {number}',
      loading: 'Chargement…',
      empty: 'Aucune facture en {year}',
      loadError: 'L’historique de facturation n’a pas pu être chargé.',
      retry: 'Réessayer',
    },
    panelCard: {
      edit: 'Modifier {title}',
      fold: 'Replier {title}',
      unfold: 'Déplier {title}',
    },
    companyBillingContacts: {
      card: {
        title: 'Notifications',
        add: 'Ajouter un destinataire',
        edit: 'Modifier {name}',
        loading: 'Chargement des destinataires…',
        loadError: 'Les destinataires des factures n’ont pas pu être chargés.',
        retry: 'Réessayer',
        nobody: 'Personne ne reçoit les factures ni les relances.',
        groups: {
          members: {
            title: 'Inscrit sur Jobbiz',
            info: 'Membres de l’entreprise, avec un compte Jobbiz, qui reçoivent les factures ou les relances.',
            empty: 'Aucun membre ne reçoit les factures ni les relances.',
          },
          externals: {
            title: 'Non inscrit sur Jobbiz',
            info: 'Personnes sans compte Jobbiz, ajoutées seulement pour recevoir les factures ou les relances.',
            empty: 'Aucun contact sans compte.',
          },
        },
        receives: {
          both: 'Factures, relances',
          invoices: 'Factures',
          reminders: 'Relances',
          none: 'Aucune notification',
        },
        memberStatus: {
          pending: 'Invitation en attente',
        },
      },
      add: {
        title: 'Ajouter un contact de facturation',
        loading: 'Chargement des membres…',
        loadError: 'Les membres de l’entreprise n’ont pas pu être chargés.',
        retry: 'Réessayer',
      },
      picker: {
        intro:
          'Choisissez un membre de l’entreprise ou ajoutez un contact de facturation sans compte Jobbiz. Les factures lui seront envoyées par mail.',
        searchLabel: 'Rechercher un membre ou saisir une adresse e-mail',
        searchPlaceholder: 'Nom, prénom ou e-mail',
        membersGroup: 'Membres de l’entreprise',
        alreadyRecipient: 'Déjà destinataire',
        noMember: 'Aucun membre ne correspond à la recherche.',
        addExternal: 'Ajouter « {query} » comme contact de facturation',
        addExternalHint: 'Reçoit les factures par mail, sans compte Jobbiz',
      },
      member: {
        editTitle: 'Modifier le contact de facturation',
        remove: 'Retirer des destinataires',
      },
      external: {
        editTitle: 'Modifier le contact de facturation',
        description:
          'Cette personne recevra les factures par mail, sans compte Jobbiz. Elle sera aussi ajoutée sur HubSpot.',
        email: 'E-mail',
        firstName: 'Prénom',
        lastName: 'Nom',
        phone: 'Numéro (optionnel)',
        invite: 'Inviter sur Jobbiz',
        delete: 'Supprimer ce contact',
        deleteTitle: 'Supprimer {name} ?',
        deleteConfirmation: 'Il ne recevra plus les factures ni les relances.',
        confirmDelete: 'Supprimer',
        deleting: 'Suppression…',
      },
      notifications: {
        label: 'Notifications',
        invoices: 'Factures',
        invoicesHint: 'Nouvelle facture émise',
        reminders: 'Relances',
        remindersHint: 'Rappels d’échéances et relances d’impayés',
      },
      actions: {
        add: 'Ajouter',
        back: 'Retour',
        cancel: 'Annuler',
        save: 'Enregistrer',
        saving: 'Enregistrement…',
      },
      toasts: {
        added: 'Contact de facturation ajouté.',
        saved: 'Contact de facturation enregistré.',
        removed: 'Retiré des destinataires.',
        deleted: 'Contact de facturation supprimé.',
      },
      errors: {
        required: 'Ce champ est requis.',
        nameTooLong: '35 caractères au plus.',
        emailInvalid: 'Adresse e-mail invalide.',
        phoneInvalid: 'Numéro invalide.',
        contactIsMember:
          'Cette adresse est celle d’un membre de l’entreprise : choisissez-le dans la recherche.',
        contactExists:
          'Cette adresse est déjà un contact de facturation de l’entreprise.',
        notificationsEmpty: 'Cochez au moins une case : Factures ou Relances.',
        notificationsInvalid: 'Ces notifications ne sont pas valides.',
        contactNotFound: 'Ce contact de facturation n’existe plus.',
        memberNotFound: 'Ce membre ne fait plus partie de l’entreprise.',
        companyNotFound: 'Entreprise introuvable.',
        generic: 'Une erreur est survenue, réessayez.',
      },
      activity: {
        ajouter_contact_facturation: 'a ajouté le contact de facturation',
        modifier_contact_facturation: 'a modifié le contact de facturation',
        supprimer_contact_facturation: 'a supprimé le contact de facturation',
        fields: {
          email: 'E-mail',
          firstname: 'Prénom',
          lastname: 'Nom',
          phone: 'Numéro',
          invoices: 'Factures',
          reminders: 'Relances',
        },
        line: '{field} : {before} → {after}',
        yes: 'Oui',
        no: 'Non',
        empty: '—',
      },
    },
    createMission: {
      perimeter: {
        title: 'Périmètre',
        description:
          'Les managers du périmètre choisi voient la mission. Les directeurs et administrateurs voient toujours toutes les missions.',
        label: 'Périmètre de la mission',
        none: 'Aucun périmètre',
        noneHint: 'Visible par tous les managers',
        loading: 'Chargement des périmètres…',
        loadError:
          'Les périmètres de l’entreprise n’ont pas pu être chargés : sans eux, la mission sera visible par tous les managers.',
        retry: 'Réessayer',
        errors: {
          notFound:
            'Le périmètre choisi n’existe plus : la liste a été actualisée, choisissez-en un autre.',
          archived:
            'Le périmètre choisi vient d’être archivé : la liste a été actualisée, choisissez-en un autre.',
        },
      },
    },
  },
};
